// extracted by mini-css-extract-plugin
module.exports = {"modal_footer":"zoeken-delete_modal_footer__2YXhm","button_container":"zoeken-delete_button_container__3uYyZ","delete":"zoeken-delete_delete__RGXyy"};